(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
	$(document).ready(function() {
		$('.accordion .accordion__container--content').each(function(index, item){
			let myParentId = $(item).attr('id');
			$('#' + myParentId + ' .accordion__header').addClass('accordion__header--inactive');
			$('#' + myParentId + ' .accordion__header').click(function (e) {
				e.preventDefault();
				if($(this).is('.accordion__header--inactive')) {
					$('#' + myParentId + ' .accordion__header--active').removeClass('accordion__header--active').addClass('accordion__header--inactive').next().velocity("slideUp", { duration: 500, easing: "easeOutCubic" }).removeClass('accordion__content--open');
					$(this).addClass('accordion__header--active').removeClass('accordion__header--inactive');
					$elem = $(this);
					$(this).next().velocity("slideDown", { duration: 500, easing: "easeOutCubic", complete: function() {
					$elem.velocity('scroll', {offset: - $('header').outerHeight() - $('#shopify-section-home_announcement').outerHeight() - 80});
					}, progress: function(elements, complete, remaining, start, tweenValue) {
					} }).addClass('accordion__content--open');
				}
				else {
					$(this).removeClass('accordion__header--active').addClass('accordion__header--inactive');
					$(this).next().velocity("slideUp", { duration: 500, easing: "easeOutCubic" }).removeClass('accordion__content--open');
				}
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-list"] && !Shopify.designMode) return;
  try {
    
	$(document).ready(function() {
		$('.accordion .accordion__container--content').each(function(index, item){
			let myParentId = $(item).attr('id');
			$('#' + myParentId + ' .accordion__header').addClass('accordion__header--inactive');
			$('#' + myParentId + ' .accordion__header').click(function (e) {
				e.preventDefault();
				if($(this).is('.accordion__header--inactive')) {
					$('#' + myParentId + ' .accordion__header--active').removeClass('accordion__header--active').addClass('accordion__header--inactive').next().velocity("slideUp", { duration: 500, easing: "easeOutCubic" }).removeClass('accordion__content--open');
					$(this).addClass('accordion__header--active').removeClass('accordion__header--inactive');
					$elem = $(this);
					$(this).next().velocity("slideDown", { duration: 500, easing: "easeOutCubic", complete: function() {
					$elem.velocity('scroll', {offset: - $('header').outerHeight() - $('#shopify-section-home_announcement').outerHeight() - 80});
					}, progress: function(elements, complete, remaining, start, tweenValue) {
					} }).addClass('accordion__content--open');
				}
				else {
					$(this).removeClass('accordion__header--active').addClass('accordion__header--inactive');
					$(this).next().velocity("slideUp", { duration: 500, easing: "easeOutCubic" }).removeClass('accordion__content--open');
				}
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pairs-well-with"] && !Shopify.designMode) return;
  try {
    
var relatedProductsSwiper = new Swiper(".related-products__row", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 21,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        640: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 3
        },
        1367: {
            slidesPerView: 4
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var relatedProductsSwiper = new Swiper(".related-products__row", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        640: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 3
        },
        1367: {
            slidesPerView: 4
        }
    },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"] && !Shopify.designMode) return;
  try {
    
(function x(){
	console.log('we should see this only once for a section');
})();
function y(a){
	console.log(`${a.toUpperCase()}`);
}

  } catch(e) { console.error(e); }
})();
})();
